<template>
    <div class="common-card-score-metric">
        <div class="implant-score" @click.stop.prevent="openWell">
            <span class="title" :class="scoreColor">
                {{ $translate('well') }} {{ well.esId }}
            </span>

            <span v-b-tooltip.hover class="value" :class="scoreColor" :title="tooltipTitle">
                <span class="score_title">{{ scoreTitle }}</span>
                {{ formattedScore }}
            </span>
        </div>

        <div class="score-tooltip">
            <img :src="image" alt="" />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import UIUtils from '../../../business/utils/UIUtils'

export default {
    name: 'CommonCardScoreMetric',
    props: {
        well: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapState({
            selectedTenant: state => state.common.selectedTenant
        }),
        score() {
            return this.well.inferenceData.kidScore
        },
        formattedScore() {
            return UIUtils.formatScore(this.score) || this.$translate('na')
        },
        scoreColor() {
            return UIUtils.getKidScoreColor(this.selectedTenant, this.score, true, true)
        },
        scoreTitle() {
            return this.$translate('eq_score')
        },
        tooltipTitle() {
            return this.$translate('the_chance_for_a_successful_implantation')
        },
        image() {
            return this.well.lastImageUrl
        }
    },
    methods: {
        openWell() {
            this.$mainController.selectWell(this.well)
        }
    }
}
</script>

<style lang="scss" scoped>
.common-card-score-metric {
    display: flex;

    .implant-score {
        display: flex;
        cursor: pointer;
        width: 100%;

        .title {
            border-top-left-radius: $border-radius-lg;
            border-bottom-left-radius: $border-radius-lg;
            font-size: 1rem;
            white-space: nowrap;
            padding-left: 0.75rem;
            padding-bottom: 0.5rem;
            padding-top: 0.5rem;
        }

        .value {
            display: flex;
            overflow-x: hidden;
            white-space: nowrap;
            border-top-right-radius: $border-radius-lg;
            border-bottom-right-radius: $border-radius-lg;
            font-size: 1rem;
            font-weight: 600;
            padding-left: 1rem;
            padding-bottom: 0.5rem;
            padding-top: 0.5rem;
        }
    }
}
</style>

<style lang="scss">
.common-card-score-metric {
    .implant-score {
        border: 0.1rem solid transparent;
        transition: all 0.2s;

        .title {
            flex: 1;
            transition: all 0.2s;
            color: $light-3 !important;
            background-color: $dark-4 !important;
        }

        .value {
            width: 4rem;
            transition: all 0.2s;
            background-color: $dark;

            &.rag-red-text {
                color: $red !important;
                background-color: $red-alpha !important;
            }
            &.rag-amber-text {
                color: $orange !important;
                background-color: $orange-alpha !important;
            }
            &.rag-green {
                color: $dark-4 !important;
                background-color: $green !important;
            }

            .score_title {
                transition: all 0.2s;
                width: 0;
                opacity: 0;
            }
        }
        &:hover {
            .title {
                background-color: $dark !important;

                &.rag-red-text {
                    color: $red !important;
                    background-color: $red-alpha !important;
                }

                &.rag-amber-text {
                    color: $orange !important;
                    background-color: $orange-alpha !important;
                }

                &.rag-green {
                    color: $dark-4 !important;
                    background-color: $green !important;
                }
            }

            .value {
                width: 8rem;
                padding-left: 0;

                .score_title {
                    text-align: center;
                    opacity: 1;
                    width: 5.2rem;
                }
            }
        }
    }

    .score-tooltip {
        display: none;
    }

    @media screen and #{$new-break4open} {
        &:hover {
            .score-tooltip {
                display: block;
                position: absolute;
                top: 0.5rem;
                left: 0.5rem;
                @include prevent-select();

                img {
                    height: 12.8rem;
                    border-radius: $border-radius-lg;
                }
            }
        }
    }
}
</style>
